import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { getAccountInfo } from '../../api/accounts';
import Button from '../../components/UI/Button';
import ErrorCard from '../../components/UI/ErrorCard';
import InputField from '../../components/UI/Form/InputField';
import Loading from '../../components/UI/loading';
import { setIsLoggedIn } from '../../store/DeveloperApplication';
import { extractSubdomainFromAddressBar } from '../../utils';

export default function StaticAuth() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState('');
  const { register, handleSubmit } = useForm();
  const getCurrentAccount = useQuery(['current-account'], () =>
    getAccountInfo()
  );
  const subdomain = extractSubdomainFromAddressBar();

  const onSubmit = (data: any) => {
    dispatch(setIsLoggedIn(true));
    navigate('/lba-developer-application');
    // if (
    //   data.email === "aah@sein.tech" &&
    //   data.password === "sageEnterprise@22"
    // ) {
    //   dispatch(setIsLoggedIn(true));
    //   navigate("/lba-developer-application");
    // } else {
    //   setFormErrors("E-mail or Password is invalid");
    // }
  };

  const renderError = () => {
    return (
      <section className='flex-grow flex justify-center items-center text-neutralColor-normal'>
        <ErrorCard
          errorTitle='Account Subdomain Error'
          errorMsg={`Account for
                ${subdomain}
              subomain does not exist in SEIN Terminal. Please validate the
              sudomain in the browser address bar and try again.`}
        />
      </section>
    );
  };

  return (
    <>
      {getCurrentAccount.isLoading && <Loading loadingText='Loading' />}
      {getCurrentAccount.isError && renderError()}
      {getCurrentAccount.isSuccess && (
        <div className='container mx-auto flex justify-center p-6'>
          <div className='bg-white py-4 px-6 rounded-md md:max-w-md flex flex-col justify-center items-center gap-6 pb-10'>
            <h1 className='mb-0 text-primaryColor-normal text-center'>
              Developer Application Authentication
            </h1>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className='w-full lg:max-w-md'
            >
              <p className='text-tertiaryColor-normal mb-2'>{formErrors}</p>
              <InputField
                customClassName='w-full'
                label='E-mail'
                name='email'
                type='email'
                placeholder='jdoe@example.com'
                register={register}
              />
              <InputField
                customClassName='w-full'
                label='Password'
                name='password'
                type='password'
                placeholder='*************'
                register={register}
              />
              <div className='mt-5'>
                <Button label='Log In' btnStyle='btn-primary' type='submit' />
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
